import { Component, Input } from '@angular/core';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { FormGroup } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { LookupFieldComponent } from '../lookup-field/lookup-field.component';
import { FieldBase } from '@nagel-types';

@Component({
    selector: 'lib-conditional-section',
    imports: [
        MatDividerModule,
        LookupFieldComponent
    ],
    templateUrl: './conditional-section.component.html',
    styleUrl: './conditional-section.component.scss'
})
export class ConditionalSectionComponent extends BaseFieldComponent {
  @Input() override field!: FieldBase<unknown>;
  @Input() override form!: FormGroup;

  getIsExecutingRequestClass = () => {
      let className = '';

      if (this.field.isUpdating) {
          className = this.field.isUpdating() ? 'blur-sm pointer-events-none' : '';
      }

      return className;
  };
}